import 'twin.macro';
import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
  'data-testid'?: string;
}

export function SubHeader(props: Props) {
  const { children } = props;
  return (
    <div
      tw="px-2 py-2 bg-neutral-intense"
      className={props.className}
      data-testid={props['data-testid']}
    >
      {children}
    </div>
  );
}
